import { TreeSelectProps, TreeSelect as TreeSelectAntD } from 'antd';
import { FC } from 'react';

export const TreeSelect: FC<TreeSelectProps> = (props) => {
	return <TreeSelectAntD {...props} />;
};
